
import $ from "jquery"
import "plugins/select2"
import {
  onClickOutside,
} from "plugins/vanilla-clickout"
import {
  JSSelectPicker,
  InputSelector,
} from "./base"


const DEFAULT_SELECTOR = {
  scope:          ".cell-listing-filter__filter-option--no-of-bedrooms-range__wrapper",
  main:           ".js-selectpicker",
  arrow:          ".select2-selection__arrow b[role=\"presentation\"]",
  first_option:   "option:nth-of-type(1)",
  original_scope: ".listing-search-result--sorting",
}


class SortSelectPicker extends JSSelectPicker {
  protected $original_scope: JQuery

  constructor(selector?: InputSelector) {
    const merged_selector = Object.assign({}, DEFAULT_SELECTOR, selector)

    super(merged_selector, true)
    this.selector = merged_selector

    this.$original_scope = this.$el.closest(merged_selector.original_scope)

    // This object might be created even expected element does not exist
    // Thus must check existence of expected element first
    if (this.$original_scope.length > 0) {
      onClickOutside(this.$original_scope[0] as HTMLElement, (e) => {
        this.onClickout(e)
      })
    }
  }

  protected onChange(val: any){
    this.emit("val_change", val)
  }

  private onClickout(e: Event){
    const target = e.target

    if (target == null) { return }

    const $el = $(target)
    if ($el.closest(".select2-container").length > 0){
      return
    }

    import(
      "select2/dist/js/select2.full"
    )
    .then(() => {
      this.$el.select2("close")
    })
  }
}


const Factory = {
  create(selector?: InputSelector){
    return new SortSelectPicker(selector)
  },
}

export {
  Factory as default,
  Factory,
  SortSelectPicker,
}
export type {
  InputSelector,
}
